import React, { useRef } from 'react';

import CyclePurchaseDialogBox from '@Local/CyclePurchase/Components/CyclePurchaseDialogBox';
import CyclePurchaseTaskOverview from '@Local/CyclePurchase/Components/CyclePurchaseTaskOverview';
import { PageLayout } from '@Local/Components/Layout';
import useCyclePurchaseApi from '@Apis/useCyclePurchaseApi';
import useOptions from '@Util/hook/useOptions';
import useQueryManager from '@Util/hook/useQueryManager';
import { TASK_TYPE_CONFIGS, TASK_TYPE_TABS, parseTaskType } from '@Local/CyclePurchase/staticData';

// 切換分頁時的初始條件：全部狀態、第 1 頁
const initTabQuery = (taskType) => ({
    taskType,
    status: 99,
    pageIndex: 1,
    pageSize: 10,
});

const CyclePurchaseVerificationBatchPaymentPage = () => {
    const { getCyclePurchaseTasksOverviewOptionsApi } = useCyclePurchaseApi();
    const { options } = useOptions({
        getOptionsApi: getCyclePurchaseTasksOverviewOptionsApi,
        isFetchOnMount: true,
    });
    const { getQuery, setQuery } = useQueryManager();

    const dialogRef = useRef(null);
    const refreshRef = useRef(null);

    // 分頁以網址為準，缺值或不合法時視為扣款
    const taskType = parseTaskType(getQuery().taskType);
    const { actionLabel, openUploadDialogKey } = TASK_TYPE_CONFIGS[taskType];

    // 切換分頁：寫入網址（可上一頁），狀態與頁碼重置
    const handleTabChange = (_, value) => {
        setQuery(initTabQuery(parseTaskType(value)), false);
    };

    // 點擊時才取開窗函式，上傳成功後重新查詢
    const tabActions = [
        {
            label: actionLabel,
            variant: 'outlined',
            onClick: () => dialogRef.current?.[openUploadDialogKey]?.({}, () => refreshRef.current?.()),
        },
    ];

    return (
        <React.Fragment>
            <PageLayout>
                <PageLayout.Tabs tabs={TASK_TYPE_TABS} activeTab={taskType} onTabChange={handleTabChange} actions={tabActions} />
                <CyclePurchaseTaskOverview key={taskType} taskType={taskType} options={options} dialogRef={dialogRef} refreshRef={refreshRef} />
            </PageLayout>
            <CyclePurchaseDialogBox ref={dialogRef} />
        </React.Fragment>
    );
};

export default CyclePurchaseVerificationBatchPaymentPage;
